import { baseApi as api } from "../../helpers/baseApi/adminService.baseApi";
import type { ListCountriesRequestDto, ListCountriesResponseDto } from "./types";

const injectedRtkApi = api.injectEndpoints({
  endpoints: (build) => ({
    listCountries: build.query<ListCountriesResponseDto, ListCountriesRequestDto>({
      query: (queryArg) => ({
        url: `/api/v1/country/list`,
        method: "POST",
        body: queryArg,
      }),
    }),
  }),
  overrideExisting: false,
});

export default injectedRtkApi;

export const {
  useListCountriesQuery,
  useLazyListCountriesQuery,
  endpoints,
} = injectedRtkApi;
